import React, { useState } from "react";
import {
    Box,
    Typography,
    Popover,
    Avatar,
    List,
    ListItemButton,
    ListItemText,
    ListItemIcon,
    Grid,
    Chip
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PaperliveLogo from '../../Header/paperlive_only_p.png';
import { EXECUTIVE_PG_DEVOPS_PROGRAM } from "../../constants/AzureDevops";

export default function CourseDropdown({ children }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [category, setCategory] = useState("devops");

    const open = Boolean(anchorEl);
    const handleOpen = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const devopsCourses = [
        {
            title: EXECUTIVE_PG_DEVOPS_PROGRAM,
            subtitle: "Paperlive Learning | Microsoft & AWS",
            img: PaperliveLogo,
            url: "/devops-training-online"
        },
        {
            title: "DevOps and Cloud with GenAI Master Program",
            subtitle: "Paperlive Learning | Microsoft",
            img: PaperliveLogo,
            url: "/devops-and-cloud-training-online"
        },
        {
            title: "DevOps Certification Training",
            subtitle: "Paperlive Learning | Microsoft",
            img: PaperliveLogo,
            url: "/devops-certification-training"
        },
        {
            title: "AWS Certification Training",
            subtitle: "Paperlive Learning",
            img: PaperliveLogo,
            url: "/aws-solution-architect"
        },
        {
            title: "Azure Certification Training",
            subtitle: "Paperlive Learning | Microsoft",
            img: PaperliveLogo,
            url: "/microsoft-azure"
        },
        {
            title: "GCP Certification Training",
            subtitle: "Paperlive Learning",
            img: PaperliveLogo,
            url: "/google-cloud-platform"
        },
    ];

    const fullstackCourses = [
        {
            title: "Full Stack Web Development with GenAI",
            subtitle: "Paperlive Learning | Microsoft",
            img: PaperliveLogo,
            tag: "New",
            url: "/full-stack-web-development"
        },
    ];

    const dataScienceCourses = [
        {
            title: "AI and Data Science Master Program",
            subtitle: "Paperlive Learning | Microsoft",
            img: PaperliveLogo,
            url: "/data-science-training-online"
        },
    ];

    const courses =
        category === "devops"
            ? devopsCourses
            : category === "fullstack"
                ? fullstackCourses
                : dataScienceCourses;

    const handleClick = (url) => {
        window.open(url, "_self");
    };

    return (
        <>
            <Typography
                sx={{
                    cursor: "pointer",
                    "&:hover": { color: "#8C00FF" },
                    fontFamily: "Poppins",
                    fontWeight: 500
                }}
                onClick={handleOpen}
            >
                {children}
            </Typography>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                PaperProps={{
                    sx: {
                        mt: 1,
                        borderRadius: 3,
                        width: 920,
                        overflow: "hidden",
                        fontFamily: "Poppins",
                        background: "#fdfcff",
                        boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                    },
                }}
            >
                <Grid container>
                    {/* LEFT PANEL */}
                    <Grid
                        item
                        xs={4}
                        sx={{
                            background: "linear-gradient(180deg, #f5f2ff, #faf7ff)",
                            borderRight: "1px solid #e0e0e0",
                            p: 2,
                        }}
                    >
                        <Typography
                            fontWeight={700}
                            mb={2}
                            fontSize="0.9rem"
                            sx={{ opacity: 0.9, fontFamily: "Poppins" }}
                        >
                            Categories
                        </Typography>

                        <List>
                            <ListItemButton
                                selected={category === "devops"}
                                onClick={() => setCategory("devops")}
                                sx={{
                                    borderRadius: 2,
                                    mb: 1,
                                    pl: 2,
                                    position: "relative",
                                    "& .MuiListItemText-primary": {
                                        fontWeight: category === "devops" ? 700 : 500,
                                        color: category === "devops" ? "#8C00FF" : "inherit",
                                    },
                                    "&.Mui-selected::before": {
                                        content: '""',
                                        position: "absolute",
                                        left: 0,
                                        top: 0,
                                        bottom: 0,
                                        width: 5,
                                        borderRadius: "5px 0 0 5px",
                                        background: "#8C00FF",
                                    },
                                    "&.Mui-selected": {
                                        background: "#fff",
                                    },
                                }}
                            >
                                <ListItemText primary="DevOps" />
                                {category === "devops" && (
                                    <ListItemIcon sx={{ minWidth: 30 }}>
                                        <ChevronRightIcon sx={{ color: "#8C00FF" }} />
                                    </ListItemIcon>
                                )}
                            </ListItemButton>

                            <ListItemButton
                                selected={category === "fullstack"}
                                onClick={() => setCategory("fullstack")}
                                sx={{
                                    borderRadius: 2,
                                    pl: 2,
                                    position: "relative",
                                    "& .MuiListItemText-primary": {
                                        fontWeight: category === "fullstack" ? 700 : 500,
                                        color: category === "fullstack" ? "#8C00FF" : "inherit",
                                    },
                                    "&.Mui-selected::before": {
                                        content: '""',
                                        position: "absolute",
                                        left: 0,
                                        top: 0,
                                        bottom: 0,
                                        width: 5,
                                        borderRadius: "5px 0 0 5px",
                                        background: "#8C00FF",
                                    },
                                    "&.Mui-selected": {
                                        background: "#fff",
                                    },
                                }}
                            >
                                <ListItemText primary="Full Stack" />
                                {category === "fullstack" && (
                                    <ListItemIcon sx={{ minWidth: 30 }}>
                                        <ChevronRightIcon sx={{ color: "#8C00FF" }} />
                                    </ListItemIcon>
                                )}
                            </ListItemButton>

                            <ListItemButton
                                selected={category === "datascience"}
                                onClick={() => setCategory("datascience")}
                                sx={{
                                    borderRadius: 2,
                                    mt: 1,
                                    pl: 2,
                                    position: "relative",
                                    "& .MuiListItemText-primary": {
                                        fontWeight: category === "datascience" ? 700 : 500,
                                        color: category === "datascience" ? "#8C00FF" : "inherit",
                                    },
                                    "&.Mui-selected::before": {
                                        content: '""',
                                        position: "absolute",
                                        left: 0,
                                        top: 0,
                                        bottom: 0,
                                        width: 5,
                                        borderRadius: "5px 0 0 5px",
                                        background: "#8C00FF",
                                    },
                                    "&.Mui-selected": {
                                        background: "#fff",
                                    },
                                }}
                            >
                                <ListItemText primary="Data Science" />
                                {category === "datascience" && (
                                    <ListItemIcon sx={{ minWidth: 30 }}>
                                        <ChevronRightIcon sx={{ color: "#8C00FF" }} />
                                    </ListItemIcon>
                                )}
                            </ListItemButton>
                        </List>
                    </Grid>

                    {/* RIGHT PANEL */}
                    <Grid item xs={8} sx={{ p: 3 }}>
                        <Typography
                            fontWeight={700}
                            mb={1.5}
                            sx={{ fontFamily: "Poppins" }}
                        >
                            {category === "devops"
                                ? "DevOps Programs"
                                : category === "fullstack"
                                    ? "Full Stack Programs"
                                    : "Data Science Programs"}
                        </Typography>

                        {courses.map((c) => (
                            <Box
                                key={c.title}
                                display="flex"
                                alignItems="center"
                                gap={2}
                                mb={2.5}
                                sx={{
                                    cursor: "pointer",
                                    p: 1.5,
                                    borderRadius: 2,
                                    transition: ".2s",
                                    "&:hover": {
                                        background: "#f9f6ff",
                                        transform: "translateX(3px)",
                                    },
                                }}
                                onClick={handleClick.bind(this, c.url)}
                            >
                                <Avatar
                                    src={c.img}
                                    sx={{
                                        width: 50,
                                        height: 50,
                                        backgroundColor: "black",
                                        '& img': {
                                            width: '60%',
                                            height: '60%',
                                            filter: 'invert(1)',
                                        }
                                    }}
                                />

                                <Box>
                                    <Typography fontWeight={600} fontSize="0.95rem">
                                        {c.title}
                                    </Typography>

                                    <Typography
                                        fontSize="0.78rem"
                                        color="text.secondary"
                                        sx={{ opacity: 0.85 }}
                                    >
                                        {c.subtitle}
                                    </Typography>

                                    {c.tag && (
                                        <Chip
                                            label={c.tag}
                                            size="small"
                                            sx={{
                                                mt: 0.5,
                                                fontSize: "0.7rem",
                                                borderRadius: 1,
                                                background: "linear-gradient(90deg, #8C00FF, #C000FF)",
                                                color: "#fff",
                                                fontWeight: 500,
                                            }}
                                        />
                                    )}
                                </Box>
                            </Box>
                        ))}
                    </Grid>
                </Grid>
            </Popover>
        </>
    );
}
